import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const rows = [{
  label: 'Vulnerability scanners',
  desc: 'Find issues, but produce noisy lists without clear business context.',
  score: 'Noisy'
}, {
  label: 'Traditional pentests',
  desc: 'Useful point-in-time, but stale quickly and expensive to repeat.',
  score: 'Stale'
}, {
  label: 'Enterprise validation platforms',
  desc: 'Powerful, but priced, packaged, and operated for mature security teams.',
  score: 'Heavy'
}, {
  label: 'Periscan',
  desc: 'Self-serve continuous validation. Attack-path evidence, AI risk, fix verification.',
  score: 'Proof',
  active: true
}];
// Top differentiators — 6 essentials, not 12
const winning = ['Self-serve onboarding', 'Fast first report', 'Attack-path evidence', 'AI app validation', 'Fix verification', 'SaaS-style pricing'];
export function Competitive() {
  return <section id="competitive" className="relative w-full py-32 border-t border-white/5" data-id="element-216">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-217">
        <SectionLabel number="18" label="Competitive" className="mb-8" data-id="element-218" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-219">
          <div className="lg:col-span-8" data-id="element-220">
            <SectionHeading size="xl" data-id="element-221">
              Not another scanner.
              <br data-id="element-222" />
              <span className="text-white/40" data-id="element-223">Not another pentest.</span>
            </SectionHeading>
          </div>
        </div>

        {/* Comparison table — cleaned up */}
        <div className="rounded-2xl bg-[#070a0e] border border-white/5 overflow-hidden mb-24" data-id="element-224">
          {/* Header row — desktop only */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-4 border-b border-white/5" data-id="element-225">
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-4" data-id="element-226">
              Category
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-6" data-id="element-227">
              Approach
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-2 text-right" data-id="element-228">
              Signal
            </span>
          </div>

          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className={`grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-6 border-t border-white/5 ${row.active ? 'bg-[#1a8fd4]/5' : ''}`} data-id="element-229">
              <div className="md:col-span-4 flex items-center gap-3" data-id="element-230">
                {row.active && <span className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4] shadow-[0_0_8px_#1a8fd4]" data-id="element-231" />}
                <h4 className={`text-base md:text-lg font-semibold tracking-tight ${row.active ? 'text-[#1a8fd4]' : 'text-white'}`} data-id="element-232">
                  {row.label}
                </h4>
              </div>
              <div className="md:col-span-6" data-id="element-233">
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-234">
                  {row.desc}
                </p>
              </div>
              <div className="md:col-span-2 md:text-right" data-id="element-235">
                <span className={`font-mono text-xs uppercase tracking-widest ${row.active ? 'text-[#1a8fd4]' : 'text-white/40'}`} data-id="element-236">
                  {row.score}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Why Periscan wins — focused to 6 differentiators */}
        <div data-id="element-237">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-238">
            <div className="lg:col-span-8" data-id="element-239">
              <SectionLabel number="19" label="Why Periscan Wins" className="mb-8" data-id="element-240" />
              <SectionHeading size="lg" data-id="element-241">
                Customers don't buy tools.
                <br data-id="element-242" />
                <span className="text-[#1a8fd4]" data-id="element-243">They buy confidence.</span>
              </SectionHeading>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-244">
            {winning.map((w, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="px-5 py-5 rounded-xl bg-[#070a0e] border border-white/[0.06] hover:border-[#1a8fd4]/30 transition-colors" data-id="element-245">
                <span className="font-mono text-[10px] text-[#1a8fd4]/70 block mb-2" data-id="element-246">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-base text-white font-medium leading-snug" data-id="element-247">
                  {w}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}